module.exports = __webpack_public_path__ + "img/hands.83a01aee.png";